import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instance9af4no2q3fjf as EmptyIterator_instance } from './CollectionsKt.mjs';
import {
  iterator3f5i676wpaa3g as iterator,
  SequenceScope1coiso86pqzq2 as SequenceScope,
} from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance1a0yry1hi33tg as Companion_instance,
} from './AbstractList.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().s2(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.v1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda_0(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.ql_1 = this$0;
        super($box);
        this.ol_1 = this$0.ul_1;
        this.pl_1 = this$0.tl_1;
      }
      ui() {
        if (this.ol_1 === 0) {
          this.wi();
        } else {
          var tmp = this.ql_1.rl_1[this.pl_1];
          this.vi((tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE());
          var tmp_0 = this;
          var tmp0 = this.ql_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp_0.pl_1 = (this.pl_1 + 1 | 0) % tmp0.sl_1 | 0;
          this.ol_1 = this.ol_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      static vl(buffer, filledSize) {
        var $this = this.bj();
        $this.rl_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().s2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.rl_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.rl_1.length;
          throw IllegalArgumentException().s2(toString(message_0));
        }
        $this.sl_1 = $this.rl_1.length;
        $this.tl_1 = 0;
        $this.ul_1 = filledSize;
        return $this;
      }
      static wl(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.vl(tmp$ret$0, 0);
      }
      v2() {
        return this.ul_1;
      }
      w2(index) {
        Companion_instance.n7(index, this.ul_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.tl_1 + index | 0) % this.sl_1 | 0;
        var tmp = this.rl_1[tmp$ret$0];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      xl() {
        return this.ul_1 === this.sl_1;
      }
      u1() {
        return new (RingBuffer$iterator$1())(this);
      }
      ak(array) {
        var tmp;
        if (array.length < this.ul_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.ul_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.ul_1;
        var widx = 0;
        var idx = this.tl_1;
        while (widx < size && idx < this.sl_1) {
          var tmp_0 = widx;
          var tmp_1 = this.rl_1[idx];
          result[tmp_0] = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          var tmp_2 = widx;
          var tmp_3 = this.rl_1[idx];
          result[tmp_2] = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_4 = terminateCollectionToArray(size, result);
        return isArray(tmp_4) ? tmp_4 : THROW_CCE();
      }
      n8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.ul_1;
        var tmp$ret$0 = Array(size);
        return this.ak(tmp$ret$0);
      }
      toArray() {
        return this.n8();
      }
      yl(maxCapacity) {
        var newCapacity = coerceAtMost((this.sl_1 + (this.sl_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.tl_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.rl_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.ak(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().vl(newBuffer, this.ul_1);
      }
      zl(element) {
        if (this.xl()) {
          throw IllegalStateException().o('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.tl_1 + this.ul_1 | 0) % this.sl_1 | 0;
        this.rl_1[tmp$ret$0] = element;
        this.ul_1 = this.ul_1 + 1 | 0;
      }
      am(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().s2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.ul_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.ul_1;
          throw IllegalArgumentException().s2(toString(message_0));
        }
        if (n > 0) {
          var start = this.tl_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.sl_1 | 0;
          if (start > end) {
            fill(this.rl_1, null, start, this.sl_1);
            fill(this.rl_1, null, 0, end);
          } else {
            fill(this.rl_1, null, start, end);
          }
          this.tl_1 = end;
          this.ul_1 = this.ul_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [AbstractList(), RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var bufferInitialCapacity = coerceAtMost($this.bm_1, 1024);
  var gap = $this.cm_1 - $this.bm_1 | 0;
  if (gap >= 0) {
    var buffer = ArrayList().m2(bufferInitialCapacity);
    var skip = 0;
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = $this.dm_1;
    $l$loop: while (_iterator__ex2g4s.v1()) {
      var e = _iterator__ex2g4s.w1();
      if (skip > 0) {
        skip = skip - 1 | 0;
        continue $l$loop;
      }
      buffer.n2(e);
      if (buffer.v2() === $this.bm_1) {
        var tmp = $this$iterator.vk(buffer, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if ($this.em_1) {
          buffer.f5();
        } else
          buffer = ArrayList().m2($this.bm_1);
        skip = gap;
      }
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!buffer.s1()) {
      if ($this.fm_1 || buffer.v2() === $this.bm_1) {
        var tmp_0 = $this$iterator.vk(buffer, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
      }
    }
  } else {
    var buffer_0 = RingBuffer().wl(bufferInitialCapacity);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = $this.dm_1;
    $l$loop_0: while (_iterator__ex2g4s_0.v1()) {
      var e_0 = _iterator__ex2g4s_0.w1();
      buffer_0.zl(e_0);
      if (buffer_0.xl()) {
        if (buffer_0.ul_1 < $this.bm_1) {
          buffer_0 = buffer_0.yl($this.bm_1);
          continue $l$loop_0;
        }
        var tmp_1 = $this$iterator.vk($this.em_1 ? buffer_0 : ArrayList().o2(buffer_0), $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        buffer_0.am($this.cm_1);
      }
    }
    if ($this.fm_1) {
      while (buffer_0.ul_1 > $this.cm_1) {
        var tmp_2 = $this$iterator.vk($this.em_1 ? buffer_0 : ArrayList().o2(buffer_0), $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        buffer_0.am($this.cm_1);
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!buffer_0.s1()) {
        var tmp_3 = $this$iterator.vk(buffer_0, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
      }
    }
  }
  return Unit_instance;
}
var windowedIterator$slambdaClass;
function windowedIterator$slambda() {
  if (windowedIterator$slambdaClass === VOID) {
    class $ {
      constructor($size, $step, $iterator, $reuseBuffer, $partialWindows) {
        this.bm_1 = $size;
        this.cm_1 = $step;
        this.dm_1 = $iterator;
        this.em_1 = $reuseBuffer;
        this.fm_1 = $partialWindows;
      }
      gm($this$iterator, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
      }
      ud(p1, $completion) {
        return this.gm(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    windowedIterator$slambdaClass = $;
  }
  return windowedIterator$slambdaClass;
}
function windowedIterator$slambda_0($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  var i = new (windowedIterator$slambda())($size, $step, $iterator, $reuseBuffer, $partialWindows);
  var l = ($this$iterator, $completion) => i.gm($this$iterator, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
